import $ from "jquery";


$(() => {

  $(".post-grid-block")
    .find(".isotope-wrapper")
    .addClass("post-grid");

  $(".isotope-system").on("click", ".pagination a", function(event) {
    event.preventDefault();

    const $this = $(this);
    const $postGrid = $this.parents(".post-grid-block");

    if ($postGrid.length === 0) {
      return;
    }

    const id = $postGrid.attr("id");
    $(`#${id}`).addClass("loading");

    const loadedInterval = setInterval(() => {
      if ($(`#${id} .post-grid`).hasClass("isotope-reloaded")) {
        $(`#${id}`).removeClass("loading");
        clearInterval(loadedInterval);
      }
    }, 100);
  });

});
